import { z } from 'zod'

// 사용자(relationId)마다 화면 설정을 키·값으로 저장하는 서버. 어떤 키에 무엇을 둘지는 앱의 화면이 정하므로
// domain 은 값을 해석하지 않는다. 서버는 Swagger 를 내지 않고, 요청한 키 중 저장된 것만 객체로 낸다(봉투 없음).
// 2026-10-16 기준 두 앱이 읽던 모양을 근거로 적었다.
export const RemoteStorageValuesSchema = z.record(z.string(), z.unknown())
export type RemoteStorageValues = z.infer<typeof RemoteStorageValuesSchema>
